var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Groupon.LS.Header.PNResponsiveMenu = (function() {
  function PNResponsiveMenu() {
    this.getVisibility = bind(this.getVisibility, this);
    this.bind = bind(this.bind, this);
    this.unbind = bind(this.unbind, this);
    this.alterDOM = bind(this.alterDOM, this);
    this.constructLanguageMenu = bind(this.constructLanguageMenu, this);
    this.constructUserMenu = bind(this.constructUserMenu, this);
    this.constructUserNavigation = bind(this.constructUserNavigation, this);
    this.initialize = bind(this.initialize, this);
    var $primaryNav, $userNav;
    this.initialize();
    this.unbind();
    this.$subnavs = this.constructSubNavFlyouts();
    $primaryNav = this.constructPrimaryNavigation(this.$subnavs);
    $userNav = this.constructUserNavigation(this.constructUserMenu(), this.constructLanguageMenu());
    this.$menu.append($primaryNav, $userNav);
    this.dedupIDs();
    this.alterDOM();
    this.bind();
  }

  PNResponsiveMenu.prototype.initialize = function() {
    this.$menu = $('#ls-resp-menu');
    this.$body = $('body');
    this.$headerRow = $('#ls-header-top-row');
    this.$overlay = $('#ls-resp-overlay');
    this.$searchBar = $('#ls-search-bar-wrapper');
    this.$userMenu = $('#ls-my-stuff');
    this.$responsiveMenuWrapper = $('#ls-resp-menu-wrapper');
    this.greenHeader = $('.ui-v3').length;
    this.popoverActiveClass = 'responsive-show-500';
    this.popoverTriggerActiveClass = 'ls-resp-active';
    this.$menuTrigger = $('#ls-resp-menu-trigger');
    this.$searchTrigger = $('#ls-resp-search-trigger');
    return this.$backButton = $('#ls-resp-back-button');
  };

  PNResponsiveMenu.prototype.constructPrimaryNavigation = function(subNavs) {
    var $primaryNav;
    $primaryNav = $('#ls-channel-nav li:not(li.p-nav-divider,li.ls-exclude-resp-nav)').clone().attr({
      role: 'menuitem',
      style: null,
      "class": 'ls-resp-menu-item'
    }).each(function() {
      var $this, i, id, len, subnav;
      id = 'subnav-' + this.id;
      for (i = 0, len = subNavs.length; i < len; i++) {
        subnav = subNavs[i];
        if (subnav.id === id && subnav.children.length) {
          subnav.id = 'ls-resp-' + this.id.replace('-tab', '-menu');
          $(subnav).attr({
            'aria-labelled': null,
            'aria-labelledby': null,
            'aria-hidden': null
          });
          $this = $(this);
          $this.children('a').attr({
            id: null,
            role: null,
            tabindex: null,
            'aria-haspopup': null,
            'aria-owns': null
          });
          $this.addClass('icon-arrow-down-large').append(subnav);
        }
      }
      return this.id = 'ls-resp-' + this.id.replace('-tab', '-trigger');
    });
    $primaryNav.find('.icon-home').removeClass();
    return $primaryNav;
  };

  PNResponsiveMenu.prototype.constructSubNavFlyouts = function() {
    var $subNavs;
    $subNavs = $('.subnav-flyout').clone().attr({
      'aria-hidden': 'true',
      role: 'menu',
      "class": 'ls-resp-submenu hide',
      style: null
    });
    $subNavs.find('.subnav-megamind').remove();
    $subNavs.find('.subnav-header').remove();
    $subNavs.find('.subnav-top-categories').remove();
    $subNavs.find('.ls-exclude-resp-sub-nav').remove();
    $subNavs.find('.subnav-link').addClass('ls-resp-submenu-item').unwrap();
    $subNavs.find('.two-column .subnav-link').unwrap().unwrap();
    return $subNavs;
  };

  PNResponsiveMenu.prototype.constructUserNavigation = function($userMenu, $langMenu) {
    var $cart, $signOut, $userName, $userNav;
    $userNav = $('.ls-user-item, .user-menu-item').clone().wrap('<li class="ls-resp-menu-item"></li>').parent();
    if ($langMenu.length) {
      $userNav = $langMenu.add($userNav);
    }
    if (($userName = $userNav.find('.user-name')).length) {
      $userName.attr({
        href: null,
        id: 'ls-resp-user-name',
        "class": 'icon-user',
        role: null,
        tabindex: null,
        'aria-haspopup': null,
        'aria-owns': null,
        'aria-describedby': null
      }).text($userName.attr('data-user-name')).parent().attr({
        id: 'subnav-usermenu-menu',
        "class": 'ls-resp-menu-item ls-resp-menu-item-user icon-arrow-down-large'
      }).append($userMenu);
      $signOut = this.$userMenu.find('#sign-out').clone().attr({
        "class": null
      }).wrap('<li class="ls-resp-menu-item"></li>').parent();
      $userNav = $userNav.add($signOut);
    }
    if (($cart = $userNav.find('.cart-widget')).length) {
      $cart = $cart.find('a');
      $userNav.find('.cart-widget').replaceWith($cart);
    }
    $userNav.find('.ls-user-item, .user-menu-item').removeClass();
    $userNav.eq(0).addClass('ls-resp-menu-divider');
    return $userNav;
  };

  PNResponsiveMenu.prototype.constructUserMenu = function() {
    var $userMenu;
    $userMenu = {};
    if (this.$userMenu.length) {
      $userMenu = this.$userMenu.clone().attr({
        "class": 'ls-resp-submenu hide',
        id: 'ls-resp-user-menu',
        role: 'menu',
        'aria-labelled': null,
        'aria-labelledby': null,
        'aria-hidden': null
      });
      $userMenu.find('#sign-out').remove();
      $userMenu.find('a').addClass('ls-resp-submenu-item').each(function() {
        return this.id = 'ls-resp-' + this.id;
      });
      this.$subnavs = this.$subnavs.add($userMenu);
    }
    return $userMenu;
  };

  PNResponsiveMenu.prototype.constructLanguageMenu = function() {
    var $langMenu, $langMenuSelector;
    $langMenuSelector = {};
    if ($('.lang-menu').length) {
      $langMenuSelector = $('<span />').text($('#ls-lang-selected').text().trim()).wrap('<li></li>').parent().attr({
        id: 'ls-resp-lang-trigger',
        "class": 'ls-resp-menu-item ls-resp-lang-trigger icon-arrow-down-large'
      });
      $langMenu = $('#ls-lang-list').clone().attr({
        id: 'ls-resp-lang-menu',
        "class": 'ls-resp-submenu hide',
        role: 'menu',
        'aria-labelled': null,
        'aria-labelledby': null,
        'aria-hidden': null
      });
      $langMenu.find('a').addClass('ls-resp-submenu-item');
      $langMenuSelector.append($langMenu);
      this.$subnavs = this.$subnavs.add($langMenu);
    }
    return $langMenuSelector;
  };

  PNResponsiveMenu.prototype.dedupIDs = function() {
    return this.$responsiveMenuWrapper.find('*[id]').each(function() {
      if (!this.id.match(/ls-resp-/)) {
        return this.id = "ls-resp-" + this.id;
      }
    });
  };

  PNResponsiveMenu.prototype.alterDOM = function() {
    $('.header').prepend([this.$menuTrigger, this.$backButton, this.$searchTrigger]);
    $('.header-v2').after(this.$overlay);
    return this.$body.prepend(this.$responsiveMenuWrapper);
  };

  PNResponsiveMenu.prototype.unbind = function() {
    this.$searchTrigger.off('tap');
    this.$menuTrigger.off('tap');
    this.$overlay.off('tap');
    $('.ls-resp-submenu').parent('li').off('tap');
    $('.ls-resp-submenu a').off('tap');
    return this.$menu.empty();
  };

  PNResponsiveMenu.prototype.bind = function() {
    var $navWithMenu;
    this.$searchTrigger.on('tap', (function(_this) {
      return function(e) {
        var menuVisible;
        e.preventDefault();
        e.stopImmediatePropagation();
        menuVisible = _this.getVisibility().menuVisible;
        if (menuVisible) {
          _this.hideRespMenu();
        }
        if (!menuVisible) {
          _this.toggleOverlay();
        }
        if (_this.greenHeader) {
          if (!menuVisible) {
            _this.$body.toggleClass('noscroll');
          }
        } else {
          _this.$body.removeClass('noscroll');
        }
        _this.$overlay.addClass('ls-resp-overlay-search-v3');
        _this.$searchTrigger.toggleClass(_this.popoverTriggerActiveClass);
        _this.$searchBar.toggleClass(_this.popoverActiveClass);
        return $('#search').focus();
      };
    })(this));
    this.$menuTrigger.on('tap', (function(_this) {
      return function(e) {
        var searchVisible;
        e.stopImmediatePropagation();
        searchVisible = _this.getVisibility().searchVisible;
        if (searchVisible) {
          _this.hideRespSearch();
        }
        if (!searchVisible) {
          _this.toggleOverlay();
        }
        if (_this.greenHeader) {
          if (!searchVisible) {
            _this.$body.toggleClass('noscroll');
          }
        } else {
          _this.$body.toggleClass('noscroll');
        }
        _this.$body.toggleClass('show-responsive-menu');
        _this.$overlay.removeClass('ls-resp-overlay-search-v3');
        _this.$menuTrigger.toggleClass(_this.popoverTriggerActiveClass);
        return _this.toggleAriaHidden(_this.$responsiveMenuWrapper);
      };
    })(this));
    this.$overlay.on('tap', (function(_this) {
      return function(e) {
        e.preventDefault();
        _this.hideRespSearch();
        _this.hideRespMenu();
        return _this.hideOverlay();
      };
    })(this));
    $navWithMenu = $('.ls-resp-submenu').parent('li');
    $navWithMenu.on('tap', (function(_this) {
      return function(e) {
        var $flyout, $tab, $visibleSubnavs;
        $tab = $(e.currentTarget);
        $visibleSubnavs = _this.$subnavs.not('.hide').addClass('hide');
        $navWithMenu.removeClass('ls-resp-open-menu');
        $flyout = $tab.children('.ls-resp-submenu');
        if ($flyout.length && !$flyout.is($visibleSubnavs)) {
          $tab.addClass('ls-resp-open-menu');
          $flyout.removeClass('hide');
          return $flyout.find('.ls-lazy').lazyload();
        }
      };
    })(this));
    return $('.ls-resp-submenu a').on('tap', function(e) {
      return e.stopImmediatePropagation();
    });
  };

  PNResponsiveMenu.prototype.toggleAriaHidden = function($el) {
    var ariaHidden;
    ariaHidden = $el.attr('aria-hidden');
    ariaHidden = ariaHidden === 'true' ? 'false' : 'true';
    return $el.attr('aria-hidden', ariaHidden);
  };

  PNResponsiveMenu.prototype.getAttributes = function(elements, attribute) {
    var attributeArray, el, i, len;
    attributeArray = [];
    for (i = 0, len = elements.length; i < len; i++) {
      el = elements[i];
      attributeArray.push($(el).attr(attribute).parent('li').removeClass('ls-resp-open-menu'));
    }
    return attributeArray;
  };

  PNResponsiveMenu.prototype.getVisibility = function() {
    return {
      searchVisible: this.$searchBar.is(':visible'),
      menuVisible: this.$responsiveMenuWrapper.is(':visible')
    };
  };

  PNResponsiveMenu.prototype.hideRespSearch = function() {
    if (this.$searchBar.is(':visible')) {
      this.$searchTrigger.removeClass(this.popoverTriggerActiveClass);
      return this.$searchBar.removeClass(this.popoverActiveClass);
    }
  };

  PNResponsiveMenu.prototype.hideRespMenu = function() {
    this.$body.removeClass('show-responsive-menu');
    return this.$menuTrigger.removeClass(this.popoverTriggerActiveClass);
  };

  PNResponsiveMenu.prototype.hideOverlay = function() {
    this.$overlay.hide();
    return this.$body.removeClass('noscroll');
  };

  PNResponsiveMenu.prototype.toggleOverlay = function() {
    return this.$overlay.toggle();
  };

  PNResponsiveMenu.prototype.removeAria = function(menu, trigger) {
    return $(menu).attr({
      'aria-labelled': null,
      'aria-labelledby': null,
      'aria-hidden': null
    });
  };

  return PNResponsiveMenu;

})();

//# sourceMappingURL=data:application/json;base64,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
